var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Groupon.LS.Header.PNResponsiveMenu = (function() {
  function PNResponsiveMenu() {
    this.getVisibility = bind(this.getVisibility, this);
    this.bind = bind(this.bind, this);
    this.unbind = bind(this.unbind, this);
    this.alterDOM = bind(this.alterDOM, this);
    this.constructLanguageMenu = bind(this.constructLanguageMenu, this);
    this.constructUserMenu = bind(this.constructUserMenu, this);
    this.constructUserNavigation = bind(this.constructUserNavigation, this);
    this.initialize = bind(this.initialize, this);
    var $primaryNav, $userNav;
    this.initialize();
    this.unbind();
    this.$subnavs = this.constructSubNavFlyouts();
    $primaryNav = this.constructPrimaryNavigation(this.$subnavs);
    $userNav = this.constructUserNavigation(this.constructUserMenu(), this.constructLanguageMenu());
    this.$menu.append($primaryNav, $userNav);
    this.dedupIDs();
    this.alterDOM();
    this.bind();
  }

  PNResponsiveMenu.prototype.initialize = function() {
    this.$menu = $('#ls-resp-menu');
    this.$body = $('body');
    this.$headerRow = $('#ls-header-top-row');
    this.$overlay = $('#ls-resp-overlay');
    this.$searchBar = $('#ls-search-bar-wrapper');
    this.$userMenu = $('#ls-my-stuff');
    this.$responsiveMenuWrapper = $('#ls-resp-menu-wrapper');
    this.greenHeader = $('.ui-v3').length;
    this.popoverActiveClass = 'responsive-show-500';
    this.popoverTriggerActiveClass = 'ls-resp-active';
    this.$menuTrigger = $('#ls-resp-menu-trigger');
    this.$searchTrigger = $('#ls-resp-search-trigger');
    return this.$backButton = $('#ls-resp-back-button');
  };

  PNResponsiveMenu.prototype.constructPrimaryNavigation = function(subNavs) {
    var $primaryNav;
    $primaryNav = $('#ls-channel-nav li:not(li.p-nav-divider,li.ls-exclude-resp-nav)').clone().attr({
      role: 'menuitem',
      style: null,
      "class": 'ls-resp-menu-item'
    }).each(function() {
      var $this, i, id, len, subnav;
      id = 'subnav-' + this.id;
      for (i = 0, len = subNavs.length; i < len; i++) {
        subnav = subNavs[i];
        if (subnav.id === id && subnav.children.length) {
          subnav.id = 'ls-resp-' + this.id.replace('-tab', '-menu');
          $(subnav).attr({
            'aria-labelled': null,
            'aria-labelledby': null,
            'aria-hidden': null
          });
          $this = $(this);
          $this.children('a').attr({
            id: null,
            role: null,
            tabindex: null,
            'aria-haspopup': null,
            'aria-owns': null
          });
          $this.addClass('icon-arrow-down-large').append(subnav);
        }
      }
      return this.id = 'ls-resp-' + this.id.replace('-tab', '-trigger');
    });
    $primaryNav.find('.icon-home').removeClass();
    return $primaryNav;
  };

  PNResponsiveMenu.prototype.constructSubNavFlyouts = function() {
    var $subNavs;
    $subNavs = $('.subnav-flyout').clone().attr({
      'aria-hidden': 'true',
      role: 'menu',
      "class": 'ls-resp-submenu hide',
      style: null
    });
    $subNavs.find('.subnav-megamind').remove();
    $subNavs.find('.subnav-header').remove();
    $subNavs.find('.subnav-top-categories').remove();
    $subNavs.find('.ls-exclude-resp-sub-nav').remove();
    $subNavs.find('.subnav-link').addClass('ls-resp-submenu-item').unwrap();
    $subNavs.find('.two-column .subnav-link').unwrap().unwrap();
    return $subNavs;
  };

  PNResponsiveMenu.prototype.constructUserNavigation = function($userMenu, $langMenu) {
    var $cart, $signOut, $userName, $userNav;
    $userNav = $('.ls-user-item, .user-menu-item').clone().wrap('<li class="ls-resp-menu-item"></li>').parent();
    if ($langMenu.length) {
      $userNav = $langMenu.add($userNav);
    }
    if (($userName = $userNav.find('.user-name')).length) {
      $userName.attr({
        href: null,
        id: 'ls-resp-user-name',
        "class": 'icon-user',
        role: null,
        tabindex: null,
        'aria-haspopup': null,
        'aria-owns': null,
        'aria-describedby': null
      }).text($userName.attr('data-user-name')).parent().attr({
        id: 'subnav-usermenu-menu',
        "class": 'ls-resp-menu-item ls-resp-menu-item-user icon-arrow-down-large'
      }).append($userMenu);
      $signOut = this.$userMenu.find('#sign-out').clone().attr({
        "class": null
      }).wrap('<li class="ls-resp-menu-item"></li>').parent();
      $userNav = $userNav.add($signOut);
    }
    if (($cart = $userNav.find('.cart-widget')).length) {
      $cart = $cart.find('a');
      $userNav.find('.cart-widget').replaceWith($cart);
    }
    $userNav.find('.ls-user-item, .user-menu-item').removeClass();
    $userNav.eq(0).addClass('ls-resp-menu-divider');
    return $userNav;
  };

  PNResponsiveMenu.prototype.constructUserMenu = function() {
    var $userMenu;
    $userMenu = {};
    if (this.$userMenu.length) {
      $userMenu = this.$userMenu.clone().attr({
        "class": 'ls-resp-submenu hide',
        id: 'ls-resp-user-menu',
        role: 'menu',
        'aria-labelled': null,
        'aria-labelledby': null,
        'aria-hidden': null
      });
      $userMenu.find('#sign-out').remove();
      $userMenu.find('a').addClass('ls-resp-submenu-item').each(function() {
        return this.id = 'ls-resp-' + this.id;
      });
      this.$subnavs = this.$subnavs.add($userMenu);
    }
    return $userMenu;
  };

  PNResponsiveMenu.prototype.constructLanguageMenu = function() {
    var $langMenu, $langMenuSelector;
    $langMenuSelector = {};
    if ($('.lang-menu').length) {
      $langMenuSelector = $('<span />').text($('#ls-lang-selected').text().trim()).wrap('<li></li>').parent().attr({
        id: 'ls-resp-lang-trigger',
        "class": 'ls-resp-menu-item ls-resp-lang-trigger icon-arrow-down-large'
      });
      $langMenu = $('#ls-lang-list').clone().attr({
        id: 'ls-resp-lang-menu',
        "class": 'ls-resp-submenu hide',
        role: 'menu',
        'aria-labelled': null,
        'aria-labelledby': null,
        'aria-hidden': null
      });
      $langMenu.find('a').addClass('ls-resp-submenu-item');
      $langMenuSelector.append($langMenu);
      this.$subnavs = this.$subnavs.add($langMenu);
    }
    return $langMenuSelector;
  };

  PNResponsiveMenu.prototype.dedupIDs = function() {
    return this.$responsiveMenuWrapper.find('*[id]').each(function() {
      if (!this.id.match(/ls-resp-/)) {
        return this.id = "ls-resp-" + this.id;
      }
    });
  };

  PNResponsiveMenu.prototype.alterDOM = function() {
    $('.header').prepend([this.$menuTrigger, this.$backButton, this.$searchTrigger]);
    $('.header-v2').after(this.$overlay);
    return this.$body.prepend(this.$responsiveMenuWrapper);
  };

  PNResponsiveMenu.prototype.unbind = function() {
    this.$searchTrigger.off('tap');
    this.$menuTrigger.off('tap');
    this.$overlay.off('tap');
    $('.ls-resp-submenu').parent('li').off('tap');
    $('.ls-resp-submenu a').off('tap');
    return this.$menu.empty();
  };

  PNResponsiveMenu.prototype.bind = function() {
    var $navWithMenu;
    this.$searchTrigger.on('tap', (function(_this) {
      return function(e) {
        var menuVisible;
        e.preventDefault();
        e.stopImmediatePropagation();
        menuVisible = _this.getVisibility().menuVisible;
        if (menuVisible) {
          _this.hideRespMenu();
        }
        if (!menuVisible) {
          _this.toggleOverlay();
        }
        if (_this.greenHeader) {
          if (!menuVisible) {
            _this.$body.toggleClass('noscroll');
          }
        } else {
          _this.$body.removeClass('noscroll');
        }
        _this.$overlay.addClass('ls-resp-overlay-search-v3');
        _this.$searchTrigger.toggleClass(_this.popoverTriggerActiveClass);
        _this.$searchBar.toggleClass(_this.popoverActiveClass);
        return $('#search').focus();
      };
    })(this));
    this.$menuTrigger.on('tap', (function(_this) {
      return function(e) {
        var searchVisible;
        e.stopImmediatePropagation();
        searchVisible = _this.getVisibility().searchVisible;
        if (searchVisible) {
          _this.hideRespSearch();
        }
        if (!searchVisible) {
          _this.toggleOverlay();
        }
        if (_this.greenHeader) {
          if (!searchVisible) {
            _this.$body.toggleClass('noscroll');
          }
        } else {
          _this.$body.toggleClass('noscroll');
        }
        _this.$body.toggleClass('show-responsive-menu');
        _this.$overlay.removeClass('ls-resp-overlay-search-v3');
        _this.$menuTrigger.toggleClass(_this.popoverTriggerActiveClass);
        return _this.toggleAriaHidden(_this.$responsiveMenuWrapper);
      };
    })(this));
    this.$overlay.on('tap', (function(_this) {
      return function(e) {
        e.preventDefault();
        _this.hideRespSearch();
        _this.hideRespMenu();
        return _this.hideOverlay();
      };
    })(this));
    $navWithMenu = $('.ls-resp-submenu').parent('li');
    $navWithMenu.on('tap', (function(_this) {
      return function(e) {
        var $flyout, $tab, $visibleSubnavs;
        $tab = $(e.currentTarget);
        $visibleSubnavs = _this.$subnavs.not('.hide').addClass('hide');
        $navWithMenu.removeClass('ls-resp-open-menu');
        $flyout = $tab.children('.ls-resp-submenu');
        if ($flyout.length && !$flyout.is($visibleSubnavs)) {
          $tab.addClass('ls-resp-open-menu');
          $flyout.removeClass('hide');
          return $flyout.find('.ls-lazy').lazyload();
        }
      };
    })(this));
    return $('.ls-resp-submenu a').on('tap', function(e) {
      return e.stopImmediatePropagation();
    });
  };

  PNResponsiveMenu.prototype.toggleAriaHidden = function($el) {
    var ariaHidden;
    ariaHidden = $el.attr('aria-hidden');
    ariaHidden = ariaHidden === 'true' ? 'false' : 'true';
    return $el.attr('aria-hidden', ariaHidden);
  };

  PNResponsiveMenu.prototype.getAttributes = function(elements, attribute) {
    var attributeArray, el, i, len;
    attributeArray = [];
    for (i = 0, len = elements.length; i < len; i++) {
      el = elements[i];
      attributeArray.push($(el).attr(attribute).parent('li').removeClass('ls-resp-open-menu'));
    }
    return attributeArray;
  };

  PNResponsiveMenu.prototype.getVisibility = function() {
    return {
      searchVisible: this.$searchBar.is(':visible'),
      menuVisible: this.$responsiveMenuWrapper.is(':visible')
    };
  };

  PNResponsiveMenu.prototype.hideRespSearch = function() {
    if (this.$searchBar.is(':visible')) {
      this.$searchTrigger.removeClass(this.popoverTriggerActiveClass);
      return this.$searchBar.removeClass(this.popoverActiveClass);
    }
  };

  PNResponsiveMenu.prototype.hideRespMenu = function() {
    this.$body.removeClass('show-responsive-menu');
    return this.$menuTrigger.removeClass(this.popoverTriggerActiveClass);
  };

  PNResponsiveMenu.prototype.hideOverlay = function() {
    this.$overlay.hide();
    return this.$body.removeClass('noscroll');
  };

  PNResponsiveMenu.prototype.toggleOverlay = function() {
    return this.$overlay.toggle();
  };

  PNResponsiveMenu.prototype.removeAria = function(menu, trigger) {
    return $(menu).attr({
      'aria-labelled': null,
      'aria-labelledby': null,
      'aria-hidden': null
    });
  };

  return PNResponsiveMenu;

})();

//# sourceMappingURL=data:application/json;base64,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
